import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { EventHubFormPresentation } from './event-hub-form.presentation';
import { EventHubFormVM } from './event-hub-form.viewmodel';

type EventHubFormProps = {
    accountData: { accountId: number; accountName: string };
    saveCompletedCallback: () => Promise<void>;
    deleteCompletedCallback: () => Promise<void>;
    eventHubId?: number;
};

export const EventHubForm = withViewModel<EventHubFormProps, EventHubFormVM>(EventHubFormPresentation, async props => {
    const vm = new EventHubFormVM(
        props.accountData,
        props.saveCompletedCallback,
        props.deleteCompletedCallback,
        props.eventHubId
    );

    await vm.initialize();

    return vm;
});